define('lq/events/actions/eventAction',[
    'jquery',
    'lq/oop'
], function ($, oop) {
	'use strict';

	function EventAction(eventData, eventArg) {
	    this.eventData = eventData;
	    this.eventArg = eventArg;
	}

    oop.makeExtendable(EventAction);

    EventAction.DO_NOT_BATCH = "no-batch";
    EventAction.QUERY_BATCH = "query-batch";
    EventAction.COMMAND_BATCH = "command-batch";

    EventAction.prototype.getBatchType = function () {
        throw new Error('please override \'getBatchType()\' of EventAction');
    };

    EventAction.prototype.createEventActionRequest = function () {
        return undefined;
    };

    EventAction.prototype.execute = function (continuation, eventActionResponse) {
        continuation();
    };

    EventAction.prototype.eventIsEnabled = function (eventName) {
        return this.eventData.eventing && this.eventData.eventing[eventName] && this.eventData.eventing[eventName].enabled;
    };

    EventAction.prototype.triggerEvent = function (eventName, next, param, optionalAbortion) {
            this.piping.eventing.publish(this.eventData.eventing[eventName].raisedEventName, this.eventSource, param, next, this.getEventActionIdentifier(), optionalAbortion);
    };

    EventAction.prototype.getEventActionIdentifier = function (eventName, next, param) {
        return {
            id: this.eventActionId,
            actionInstanceId: this.rootDrop.instanceId
        };
    };

    EventAction.prototype.triggerEventIfEnabled = function (eventName, next, param) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, next, param);
        }
    };

    EventAction.prototype.triggerEventIfEnabledAndContinue = function (eventName, next, param) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, next, param);
        }
        else {
            next();
        }
    };

    EventAction.prototype.isUserLoggedInEventEnabled = function () {
        return this.eventIsEnabled('afterUserLoggedIn') || this.eventIsEnabled('userLoggedIn');
    };

    // A login or logoff that keeps the page open changes the user on purpose. The page takes over the token (and the
    // user) of the new user before anything else is sent, otherwise its next request is rejected and the page
    // reloads because the user it was rendered for is no longer the logged in user (see RuntimeDispatcher).
    EventAction.prototype.refreshCsrfTokenForNewUser = function (next) {
        var proceed = function () { next(); };
        this.piping.dispatcher.refreshCsrfToken(proceed, proceed);
    };

    // afterUserLoggedIn is the client side event after a login, userLoggedIn is kept for backwards compatibility
    EventAction.prototype.triggerUserLoggedInEvents = function (next, returnUrl) {
        var self = this;
        // the continuation can be missing, e.g. when the login is completed after polling the MFA status
        var continuation = typeof next === 'function' ? next : function () { };
        var triggerUserLoggedIn = function () {
            self.triggerEventIfEnabledAndContinue('userLoggedIn', continuation, returnUrl);
        };

        if (this.eventIsEnabled('afterUserLoggedIn'))
            this.triggerEvent('afterUserLoggedIn', triggerUserLoggedIn, returnUrl);
        else
            triggerUserLoggedIn();
    };

    EventAction.prototype.handleExecutionTrailDirty = function (continuation) {
        if (this.eventIsEnabled("onExecutionTrailDirty")) {
            this.triggerEvent("onExecutionTrailDirty", function () {
                continuation({ break: true });
            });
        } else {
            alert("Could not create report, because the data is dirty.");
            continuation({ break: true });
        }
    };

    return EventAction;
});
